// utils/session.js
export function cleanupAndLogout(setUser, socket, navigate) {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  setUser(null);
  if (socket) socket.disconnect();
  navigate('/connexion');
}
